export default __webpack_public_path__ + "images/3163efdfeef2f1a0290ee24ad4a6fc74-historic_small.webp";